export const generateCSV = data => {
  let csvData = '';
  if (Array.isArray(data)) {
    if (typeof data[0] === 'object') {
      const keys = Object.keys(data[0]);
      csvData = `${keys.join(',')}\n`;
      data.forEach(item => {
        csvData += `${Object.values(item).join(',')}\n`;
      });
    } else {
      csvData = `${data.join('\n')}`;
    }
  } else {
    csvData = `${data.join('\n')}`;
  }

  return `data:text/csv;charset=UTF-8,${encodeURIComponent(csvData)}`;
};
